function ProgressBar({ progress, overtime, className = 'mt-2', fillClass = 'bg-gradient-to-r from-orange-400 to-orange-600' }) {
  return (
    <div className={`${className} h-1.5 overflow-hidden rounded-full bg-[color:var(--app-card)]`}>
      <div
        className={`h-full rounded-full transition-all duration-1000 ${overtime ? 'bg-red-500' : fillClass}`}
        style={{ width: `${progress * 100}%` }}
      />
    </div>
  );
}

export default ProgressBar;
